import { render } from "./contact-us.vue?vue&type=template&id=428f4393&scoped=true"
import script from "./contact-us.vue?vue&type=script&lang=js"
export * from "./contact-us.vue?vue&type=script&lang=js"

import "./contact-us.vue?vue&type=style&index=0&id=428f4393&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428f4393"]])

export default __exports__